module.exports = __webpack_public_path__ + "static/media/default-profile-image.f315ccba.jpg";